"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALES_ORDER_ROLES = void 0;
var SALES_ORDER_ROLES;
(function (SALES_ORDER_ROLES) {
    SALES_ORDER_ROLES["SEARCH_SALES_ORDERS"] = "search-sales-orders";
    SALES_ORDER_ROLES["VIEW_SALES_ORDER"] = "view-sales-order";
    SALES_ORDER_ROLES["CREATE_SALES_ORDER"] = "create-sales-order";
    SALES_ORDER_ROLES["DUPLICATE_SALES_ORDER"] = "duplicate-sales-order";
    SALES_ORDER_ROLES["MODIFY_SALES_ORDER"] = "modify-sales-order";
    SALES_ORDER_ROLES["SALES_ORDER_RELEASE_ALLOCATION"] = "sales-order-release-allocation";
    SALES_ORDER_ROLES["MODIFY_SALES_ORDER_SHIPPING"] = "modify-sales-order-shipping";
    SALES_ORDER_ROLES["APPROVE_SALES_ORDER_DROP_SHIP_ADDRESS"] = "approve-sales-order-drop-ship";
    SALES_ORDER_ROLES["MODIFY_SALES_ORDER_STATUS"] = "modify-sales-order-status";
    SALES_ORDER_ROLES["DELETE_SALES_ORDERS_IMPORT_FILE"] = "delete-sales-orders-import-file";
    SALES_ORDER_ROLES["SEARCH_IMPORTED_SALES_ORDERS"] = "search-imported-sales-orders";
    SALES_ORDER_ROLES["IMPORT_SALES_ORDERS"] = "import-sales-orders";
    SALES_ORDER_ROLES["CREATE_SALES_ORDER_FILE"] = "create-sales-order-file";
})(SALES_ORDER_ROLES = exports.SALES_ORDER_ROLES || (exports.SALES_ORDER_ROLES = {}));
//# sourceMappingURL=sales-order.roles.js.map